import React, { useMemo } from 'react';
import { Avatar, Tooltip, makeStyles } from '@material-ui/core';

import RoleplayLabel from '../Common/RoleplayLabel';
import User from 'infrastructure/User';

import styles from './RoleplayDashboardList.module.scss';
import Organization from 'infrastructure/Organization';
import RoleplayCardButton from './RoleplayCardButton';
import UnassignRoleplay from '../UnassignRoleplay/UnassignRoleplay';
import DateTime from 'infrastructure/Datetime';
import AILabel from 'shared_ui_components/AIFeatures/AILabel/AILabel';

const useStylesBootstrap = makeStyles((theme) => ({
  arrow: {
    color: theme.palette.common.black,
  },
  tooltip: {
    backgroundColor: theme.palette.common.black,
  },
}));

function BootstrapTooltip(props) {
  const classes = useStylesBootstrap();

  return <Tooltip arrow classes={classes} {...props} />;
}

const DashboardRoleplayCard = ({ roleplay, active }) => {
  const user = useMemo(() => {
    if (Organization.isRep()) return roleplay?.assigned_by_user || {};
    return roleplay?.user || {};
  }, [roleplay?.assigned_by_user, roleplay?.user]);

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        {active ? (
          <BootstrapTooltip
            title={User.getUserName(user)}
            aria-label="user_name"
            placement="top-start"
          >
            <Avatar className={styles.img} alt="" src={user?.profile_pic}>
              {User.getInitial(user)}
            </Avatar>
          </BootstrapTooltip>
        ) : (
          <Avatar className={styles.img} alt="" src={user?.profile_pic}>
            {User.getInitial(user)}
          </Avatar>
        )}

        <span className={styles.headerLabel}>
          <AILabel active={active} isInteractive={roleplay?.interactive ?? false} />
          <RoleplayLabel {...roleplay?.status} />
          <UnassignRoleplay roleplay={roleplay} small />
        </span>
      </div>
      {active ? (
        <div className={styles.names}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              borderLeft: `6px solid ${roleplay?.color_code ? roleplay?.color_code : '#bdbdbd'}`,
              marginTop: '0.5rem',
              paddingLeft: '0.5rem',
            }}
          >
            <p style={{ fontWeight: 400, fontSize: '12px' }}>{roleplay?.slug_tag || ''}</p>
            <p style={{ fontWeight: 600, fontSize: '14px' }}>{roleplay?.name || ''}</p>
          </div>
          <p className={styles.deadline}>Due: {DateTime.formatMMMddyyyy(roleplay?.deadline)}</p>
        </div>
      ) : (
        <div className={styles.names}>
          <h3>{User.getUserName(user)}</h3>
          <p>{roleplay?.name || ''}</p>
          <p className={styles.deadline}>Due: {DateTime.formatMMMddyyyy(roleplay?.deadline)}</p>
        </div>
      )}
      <RoleplayCardButton
        roleplay={roleplay}
        active={active}
        isInteractive={roleplay?.interactive ?? false}
      />
    </div>
  );
};

export default DashboardRoleplayCard;
